import Vue from 'vue'
import Router from 'vue-router'
import ApiHandler from './ApiHandler'
import Home from './views/Home.vue'
import Start from './views/Start.vue'
import Vragenlijst from './views/Vragenlijst.vue'
import VragenlijstWeb from './views/VragenlijstWeb.vue'
import RapportClient from './views/RapportClient.vue'
import RapportTotaal from './views/RapportTotaal.vue'
import Login from './views/Login.vue'
import PasswordReset from './views/PasswordReset.vue'
import Beheer from './views/Beheer.vue'
import WachtOpClient from './views/WachtOpClient.vue'
import WebVinnieStart from './views/WebVinnieStart.vue'
import BeheerOverzicht from './views/BeheerOverzicht.vue'
import Users from '@/components/useradmin/Users.vue'
import Activate from '@/components/useradmin/Activate.vue'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        auth: false
      }
    },
    {
      path: '/start',
      name: 'start',
      component: Start,
      meta: {
        auth: true
      }
    },
    {
      path: '/vragenlijst/:sessie',
      name: 'vragenlijst',
      component: Vragenlijst,
      meta: {
        auth: false,
        showmenu: false,
      }
    },
    {
      path: '/vinnieweb/:sessie',
      name: 'vragenlijstweb',
      component: VragenlijstWeb,
      meta: {
        auth: false,
        showmenu: false,
      }
    },
    {
      path: '/wacht',
      name: 'wachtopclient',
      component: WachtOpClient,
      meta: {
        auth: false,
        showmenu: false,
      }
    },
    {
      path: '/rapport/client',
      name: 'rapportclient',
      component: RapportClient,
      meta: {
        auth: true
      }
    },
    {
      path: '/rapport/totaal',
      name: 'rapporttotaal',
      component: RapportTotaal,
      meta: {
        auth: true
      }
    },
    {
      path: '/beheer',
      name: 'beheer',
      component: Beheer,
      meta: {
        auth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        auth: false
      }
    },
    {
      path: '/passwordreset',
      name: 'PasswordReset',
      component: PasswordReset,
      meta: {
        auth: false
      }
    },
    {
      path: '/beheer/overzicht',
      name: 'BeheerOverzicht',
      component: BeheerOverzicht,
      meta: {
        auth: true
      }
    },
    {
      path: '/beheer/gebruikers',
      name: 'users',
      component: Users,
      meta: { auth: true }
    },
    {
      path: '/activeer',
      name: 'activeer',
      component: Activate,
      meta: { auth: false }
    },
    {
      path: '/web',
      name: 'webvinniestart',
      component: WebVinnieStart,
      meta: { auth: false, showmenu: false, }
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        auth: false
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    // Authenticatie vereist. Check of session-cookie nog geldig is.
    var auth = false;
    (new ApiHandler()).Authenticated() // Vraag server of sessie-id nog geldig is.
      .then((response) => {
        auth = (response.data.length > 0);
        if (auth)
          next(); // Sessie-id is nog geldig
        else
          next({ name: 'Login', query: { ReturnUrl: to.fullPath } }); // Sessie-id is verlopen => inlogscherm
      })
      .catch(() => {
        next({ name: 'Login', query: { ReturnUrl: to.fullPath } });
      });
  }
  else {
    next();
  }
});

export default router;